import React from 'react';

const ListingParkRules = ({ rules }) => {
    if (!rules || !rules.length || !rules[0]) {
        return '';
    }

    return (
        <div className="px-2 px-md-0">
            <div className="snif-m1 snif-semibold my-3">Park rules</div>
            {rules.map((r, i) => {
                if (!r) {
                    return null;
                }

                return (
                    <p key={i} className="snif-p">
                        {r}
                    </p>
                );
            })}
            <div className="my-4">
                <hr />
            </div>
        </div>
    );
};

export default ListingParkRules;
